import Vue from 'vue';
import browserDetect from '@/utils/browser';
import * as types from '../mutation-types';


// initial state
const state = {
  globals: {},
  likes: [],
  browser: browserDetect(),
  tags: [
    {
      name: 'Веб',
      name_plural: 'Вебa',
      name_in: 'вебе',
      tag: 'web',
      value: 2,
    },
    {
      name: 'Граф',
      name_plural: 'Графa',
      name_in: 'графе',
      tag: 'graphical',
      value: 4,
    },
    {
      name: 'Пром',
      name_plural: 'Промa',
      name_in: 'проме',
      tag: 'industrial',
      value: 1, // for uploading form
    },
    {
      name: 'Шрифт',
      name_plural: 'Шрифтa',
      name_in: 'шрифте',
      tag: 'font',
      value: 3,
    },
  ],
};

// getters
const getters = {
  globals: stateFreezed => stateFreezed.globals,
  browser: stateFreezed => stateFreezed.browser,
  likes: stateFreezed => stateFreezed.likes,
  tags: stateFreezed => stateFreezed.tags,
};

// actions
const actions = {
  fetchGlobal({ commit }) {
    Vue.http.get('global/')
    .then((response) => {
      // get body data
      commit(types.RECEIVE_GLOBAL, response.body.content);
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_GLOBAL](stateFreezed, globFetched) {
    const st = stateFreezed;
    st.globals = globFetched;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js